export default __webpack_public_path__ + "static/media/intoxication.491a5ad0.jpg";